<div class="container">
  <div class="title">
    <h1 mat-dialog-title>Repayment Report</h1>
  </div>

  <div
    class="content"
    mat-dialog-content
  >
    <table>
      <thead>
        <tr>
          <th>Outstanding</th>
          <th>Not Due</th>
          <th>Due 1-30</th>
          <th>Due 31-60</th>
          <th>Due 61-90</th>
          <th>Due 90+</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>&#8377; {{ data.outstanding }}</td>
          <td>&#8377; {{ data.notDue }}</td>
          <td>&#8377; {{ data.due1To30Days }}</td>
          <td>&#8377; {{ data.due31To60Days }}</td>
          <td>&#8377; {{ data.due61To90Days }}</td>
          <td>&#8377; {{ data.due90PlusDays }}</td>
        </tr>
      </tbody>
    </table>

    <p>
      Disclaimer: Repayment details above may be delayed upto 2 business days and do not include late payment
      charges,if any.
    </p>

    <p>For latest updated ledger, please reach out to your RM and reach out to us accounts&#64;zippmat.com</p>
  </div>

  <div
    mat-dialog-actions
    class="submit"
  >
    <button
      mat-raised-button
      (click)="onClose()"
      color="secondary"
      style="float: left"
    >
      Close
    </button>
  </div>
</div>
